export default __webpack_public_path__ + "media/zurb/img/services/process/land-img-b81dda21cb59269b44e8d6f0226e951e.png";